import React, { useEffect, useState , useCallback } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProfileCard from "@/components/ProfileCard";
import { ShieldCheck, MapPin, Clock } from "lucide-react";

export default function AgencyDetails() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/agencies/${id}`); setData(data); } catch (e) { console.warn("[AgencyDetails.jsx] non-blocking error:", e); }
    })();
  }, [id]);

  if (!data) return <div className="max-w-7xl mx-auto px-4 py-20 text-[#737373]">Loading…</div>;
  const a = data.agency;

  return (
    <div data-testid="agency-page">
      <div className="relative h-72 sm:h-96 overflow-hidden">
        {a.cover_image && <img src={a.cover_image} alt={a.name} className="w-full h-full object-cover opacity-40" />}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/30 to-[#0a0a0a]" />
        <div className="absolute inset-0 flex items-end max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-10">
          <div>
            <p className="text-overline">{a.city}</p>
            <h1 className="font-heading text-5xl sm:text-6xl text-white mt-2 font-light tracking-tight">{a.name}</h1>
            <div className="mt-4 flex flex-wrap gap-3">
              {a.verification_level === "agency_verified" && (
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs bg-emerald/30 text-emerald-200 border border-emerald/50">
                  <ShieldCheck className="w-3.5 h-3.5" /> Agency Verified
                </span>
              )}
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs bg-black/60 text-gold border border-gold/40">
                Trust {a.trust_score}/100
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <p className="text-overline mb-3">About the agency</p>
            <p className="text-[#d4d4d4] text-base leading-relaxed">{a.description}</p>
          </div>
          <div className="card-luxe rounded-lg p-5">
            <p className="text-overline mb-3">Details</p>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2 text-[#d4d4d4]"><MapPin className="w-4 h-4 text-gold" /> {a.city}</div>
              <div className="flex items-center gap-2 text-[#d4d4d4]"><Clock className="w-4 h-4 text-gold" /> {a.working_hours}</div>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <p className="text-overline">Our roster</p>
          <h2 className="font-heading text-3xl text-white mt-2 mb-8 font-light">Verified profiles</h2>
          {data.profiles.length === 0 ? (
            <p className="text-sm text-[#737373]">No profiles listed yet.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
              {data.profiles.map((p) => <ProfileCard key={p.id} profile={p} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
